import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';

import { AI_QUERY_KEY } from '../types';

/**
 * Enable an AI module
 */
const enableAIModule = async (id: number) => {
  if (!id) return console.warn(`## NO id to update AI module!`);
  const data = {
    status: 'ACTIVE',
  };
  await restoreURL().patch(`${API_CTX}/ai-modules/${id}`, data);
};

export const useEnableAIModule = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  return useMutation<void, Error, { id: number }>(
    ({ id }) => enableAIModule(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AI_QUERY_KEY);
        toast.success(`AI module activated successfully`);

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error: Error) => {
        toast.error(`An error occurs: ${error.message}`);
      },
    }
  );
};
